import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  modal: (props) => ({
    transition: `all ${theme.speed.normal}ms`,
    transform: 'translateX(0)',
    opacity: 1,
    width: (props.width === 'auto' ? '70%' : (props.width === 'fill' ? '100%' : 'calc(100% - 30px)')),
    height: (props.height === 'auto' ? 'fit-content' : (props.height === 'fill' ? '100%' : 'calc(100% - 30px)')),
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: (props.width === 'auto' ? '400px' : 'auto'),
    '&.fade-entering': { opacity: 0 },
    '&.fade-entered': { opacity: 1 },
    '&.fade-exiting': { opacity: 0 },
    '&.fade-exited': { opacity: 0 },
    '&.from-top-entering': { transform: 'translateY(-100%)' },
    '&.from-top-entered': { transform: 'translateY(0px)' },
    '&.from-top-exiting': { transform: 'translateY(-100%)' },
    '&.from-top-exited': { transform: 'translateY(-100%)' },
    '&.from-bottom-entering': { transform: 'translateY(100%)' },
    '&.from-bottom-entered': { transform: 'translateY(0px)' },
    '&.from-bottom-exiting': { transform: 'translateY(100%)' },
    '&.from-tobottomp-exited': { transform: 'translateY(100%)' },
    '&.from-start-entering': { transform: `translateX(${theme.direction.transformFactor * -100}%)` },
    '&.from-start-entered': { transform: 'translateX(0px)' },
    '&.from-start-exiting': { transform: `translateX(${theme.direction.transformFactor * -100}%)` },
    '&.from-start-exited': { transform: `translateX(${theme.direction.transformFactor * -100}%)` },
    '&.from-end-entering': { transform: `translateX(${theme.direction.transformFactor * 100}%)` },
    '&.from-end-entered': { transform: 'translateX(0px)' },
    '&.from-end-exiting': { transform: `translateX(${theme.direction.transformFactor * 100}%)` },
    '&.from-end-exited': { transform: `translateX(${theme.direction.transformFactor * 100}%)` },
  }),
  container: (props) => ({
    display: 'flex',
    position: 'fixed',
    opacity: 1,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    zIndex: props.zIndex,
    backgroundColor: props.overlay ? 'rgba(0, 0, 0, 0.1)' : 'transparent',
    justifyContent: (
      ['top', 'bottom', 'center'].includes(props.position) ? 'center' : `flex-${props.position}`
    ),
    alignItems: (
      ['start', 'end', 'center'].includes(props.position) ? 'center' : (props.position === 'bottom' ? 'flex-end' : 'flex-start')
    ),
    transition: `opacity ${theme.speed.normal}ms`,
    '&.entering': { opacity: 0 },
    '&.entered': { opacity: 1 },
    '&.exiting': { opacity: 0 },
    '&.exited': { opacity: 0 },
  }),
}));

export default useStyle;
